import './explore-filters.css';
// eslint-disable-next-line no-unused-vars
import Swiper from 'swiper';

export default (element) => {
  const currentUrl = window.location.pathname;

  const findActiveTag = () => {
    const blogsKeyword = window.TMW.Strings.blogs.urlParameter;
    let hasActiveTag = false;

    if (!currentUrl.includes(blogsKeyword)) {
      return;
    }

    const activeElement = element.querySelector(
      '[data-explore-filters-slider]',
    );
    const allSlides = activeElement.querySelectorAll(
      '[data-explore-filters-slide]',
    );
    const isLargeScreen = window.innerWidth > 1024;

    allSlides.forEach((slide) => {
      const tagLink = slide.getAttribute('href');
      const isActiveTag = tagLink === currentUrl;

      if (isActiveTag) {
        if (isLargeScreen) {
          slide.classList.add('opacity-100');
          slide.querySelector('img').classList.add('border-active');
        } else {
          slide.classList.add('border-active');
        }
      } else {
        slide.classList.add('opacity-50');
      }

      if (isActiveTag) {
        hasActiveTag = true;
      }
    });

    if (!hasActiveTag) {
      allSlides.forEach((slide) => {
        slide.classList.remove('opacity-50');
        slide.classList.add('opacity-100');
      });
    }
  };

  const setActiveSlidePosition = () => {
    const activeElement = element.querySelector(
      '[data-explore-filters-slider]',
    );
    const parentElement = element.querySelector(
      '[data-explore-filters-slides]',
    );
    const allSlides = activeElement.querySelectorAll(
      '[data-explore-filters-slide]',
    );
    const activeSlide = Array.from(allSlides).find(
      (slide) => slide.getAttribute('href') === currentUrl,
    );

    if (activeSlide) {
      parentElement.prepend(activeSlide);
    }
  };

  const calculateSlidesWidth = () => {
    const slides = document.querySelectorAll('[data-explore-filters-slide]');
    const spacing = 16;
    let slidesWidth = 0;
    slides.forEach((slide) => {
      slidesWidth += slide.offsetWidth + spacing;
    });
    return slidesWidth;
  };

  const init = () => {
    const sliderDiv = element.querySelector('[data-explore-filters-slider]');
    const slides = element.querySelector('[data-explore-filters-slides]');
    const sliderPrev = element.querySelector('[data-slider-prev]');
    const sliderNext = element.querySelector('[data-slider-next]');

    sliderDiv.classList.add('opacity-0');

    if (window.innerWidth > 1024) {
      // eslint-disable-next-line
      const slider = new Swiper(sliderDiv, {
        slidesPerGroup: 1,
        slidesPerView: 'auto',
        spaceBetween: 16,
        centeredSlides: false,
        slideWidth: 100,
        allowSlidePrev: true,
        allowSlideNext: true,
        navigation: {
          prevEl: '.swiper-button-prev',
          nextEl: '.swiper-button-next',
        },
        on: {
          init() {
            sliderDiv.classList.remove('opacity-0');
          },
        },
      });

      sliderPrev.classList.remove('hidden');
      sliderNext.classList.remove('hidden');
    } else {
      slides.classList.add('justify-center');
      sliderDiv.classList.remove('opacity-0');
    }

    if (window.innerWidth < 1024) {
      sliderDiv.classList.remove('swiper');
      sliderDiv.classList.remove('swiper-container');
      slides.classList.remove('swiper-wrapper');
    }

    const elementSetActive = document.querySelector('[data-set-active="true"]');
    if (
      elementSetActive &&
      elementSetActive.getAttribute('data-set-active') === 'true'
    ) {
      setActiveSlidePosition();
    }

    findActiveTag();
  };

  init();
  calculateSlidesWidth();
};
